export var WebGL2RenderingContext = {};
//# sourceMappingURL=WebGL2.js.map